// CORE brand mark. EKG pulse animates by default (one-shot loop, respects
// prefers-reduced-motion via the .core-mark-anim CSS in globals).
export function CoreMark({ size = 32, animated = true }: { size?: number; animated?: boolean }) {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      aria-hidden="true"
      style={{ display: 'block' }}
      className={animated ? 'core-mark-anim' : undefined}
    >
      <circle className="cm-ring" cx="100" cy="100" r="52" fill="none" stroke="currentColor" strokeWidth="11" />
      <line className="cm-axis" x1="100" y1="32" x2="100" y2="168" stroke="currentColor" strokeWidth="11" strokeLinecap="round" />
      <polyline
        className="cm-ekg"
        points="20,100 60,100 70,82 80,118 90,90 100,108 114,100 180,100"
        fill="none"
        stroke="var(--accent, #C8FF1A)"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
